import fileSize from 'filesize';
import moment from 'moment';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { icons } from '~/assets';
import BenefitModal from '~/components/BenefitModal';
import Button from '~/components/button';
import Collapse from '~/components/collapse';
import Container from '~/components/container';
import ContainerFlex from '~/components/containerFlex';
import Dialog from '~/components/dialog';
import Input from '~/components/input';
import Loading from '~/components/loading';
import useApi, { ApiMethod } from '~/hooks/useApi';
import Cartao from '~/models/cartao';
import Endereco from '~/models/endereco';
import {
  IDocumentTypes,
  IProposal,
  IProposalDocuments,
  IReference,
  IResponseGetDocumentLink,
  IResponseInformationKYC,
} from '~/models/proposal';
import ConsultUserDetailResponse, {
  ConsultclientCancelResponse,
} from '~/services/consult/user/detail/response';
import UpdateUserPayload from '~/services/consult/user/update/payload';
import IResponseDefaultError from '~/services/default-error/response';
import Endpoints from '~/services/endpoints';
import IResponseGetUserDocuments from '~/services/files/getUserDocuments/response';
import {
  IResponseContractBase64,
  IResponseContractWithdraw,
} from '~/services/loan/loan';
import { IResponseContractedsBenefits } from '~/services/sales/benefits/contracteds/response';
import { useUserRole } from '~/hooks/contexts/useUserRole';
import { transformInGlobalDate, transformInNormalDate } from '~/utils/date';
import { downloadReadableStream, openInNewTab } from '~/utils/downloads';
import * as Masks from '~/utils/masks';
import { cpfMask, IDefaultReturn } from '~/utils/masks';
import {
  dateValidator,
  emailValidator,
  IValidators,
  phoneValidator,
  socialNameValidator,
  ValidatorsNames,
} from '~/utils/validators';
import BlackListCardsDialog from '~/views/Consult/User/Detail/components/BlackListCardsDialog';
import CancelledContractSection from '~/views/Consult/User/Detail/components/CancelledContractSection';
import ClientSection from '~/views/Consult/User/Detail/components/ClientSection';
import DeleteDocumentDialog from '~/views/Consult/User/Detail/components/DeleteDocumentDialog';
import DocumentUploadDialog from '~/views/Consult/User/Detail/components/DocumentUploadDialog';
import DocumentsSection from '~/views/Consult/User/Detail/components/DocumentsSection';
import FinancialSection from '~/views/Consult/User/Detail/components/FinancialSection';
import KycHistoryDialog from '~/views/Consult/User/Detail/components/KycHistoryDialog';
import OcrSection from '~/views/Consult/User/Detail/components/OcrSection';
import ProposalSection from '~/views/Consult/User/Detail/components/ProposalSection';
import ReferencesSection from '~/views/Consult/User/Detail/components/ReferencesSection';
import WalletCardsDialog from '~/views/Consult/User/Detail/components/WalletCardsDialog';
import * as St from './styles';
import {
  CancelInvoiceItem,
  Form,
  ICardDeliveryTermImage,
  IDocumentsImage,
  isCartaoBloqueado,
  ISearchOCRProposal,
  IThemeCard,
  LocationState,
  ProductsProps,
  UserDocumentsResponse,
} from './types';

const ConsultUserDetail = (): JSX.Element => {
  const user = JSON.parse(localStorage.getItem('@NovaEra:user'));
  const [cpf] = useState<IDefaultReturn>(cpfMask(user?.cpf) as IDefaultReturn);
  const history = useHistory();
  const location = useLocation<LocationState>();
  const { state } = useLocation<{
    id: string;
    cpf: string;
    produtos: ProductsProps[];
  }>();
  const tiposProdutosCartao: string[] = state.produtos
    ? state.produtos
        .filter(
          (p) =>
            (p.tipoProduto === 'TEUCARD' && !isCartaoBloqueado(p?.status)) ||
            p.tipoProduto === 'CONVENIO',
        )
        .map((p) => p.tipoProduto)
    : ['TEUCARD'];

  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [dialogIsOpenError, setDialogIsOpenError] = useState(false);
  const [dialogText, setDialogText] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [dialogBlackListRemoveError, setDialogBlackListRemoveError] = useState(
    false,
  );
  const [dialogHistoryConsultKYC, setDialogHistoryConsultKYC] = useState(false);
  const [openDialogKYC, setOpenDialogKYC] = useState(false);
  const [dialogIsOpenSaveR, setDialogIsOpenSaveR] = useState(false);
  const [dialogMessageStatus, setDialogMessageStatus] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [dialogWalletCards, setDialogWalletCards] = useState(false);
  const [dialogBlackListCards, setDialogBlackListCards] = useState(false);
  const [errors, setErrors] = useState({} as IValidators);
  const [proposalDocuments, setProposalDocuments] = useState([]);
  const [diverseDocuments, setDiverseDocuments] = useState([]);
  const [senha, setSenha] = useState('');
  const [popUpMessage, setPopUpMessage] = useState('');
  const [popUpErrorMessage, setPopUpErrorMessage] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [popUpError, setPopUpError] = useState(false);
  const [cardInfos, setCardInfos] = useState<any>([]);
  const [addReference, setAddReference] = useState<IReference>({
    id: '',
    comentarioRef: '',
    nomeRefe: '',
    phoneRefe: { masked: '', unmasked: '' },
    relacaoCli: '',
  });

  const [addReferenceII, setAddReferenceII] = useState<IReference>({
    id: '',
    comentarioRef: '',
    nomeRefe: '',
    phoneRefe: { masked: '', unmasked: '' },
    relacaoCli: '',
  });
  const [propostaId, setPropostaId] = useState('');
  const [propostaIdConvenio, setPropostaIdConvenio] = useState('');
  const [documentsImage, setDocumentsImage] = useState({} as IDocumentsImage);
  const [documents, setDocuments] = useState({} as IResponseGetUserDocuments);
  const [dialogDeleteDocumentOpen, setDialogDeleteDocumentOpen] = useState(
    false,
  );
  const [dialogDocumentOpen, setDialogDocumentOpen] = useState(false);
  const [dialogDocumentMessage, setDialogDocumentMessage] = useState('');
  const [selectedOption, setSelectedOption] = useState(0);
  const [openBenefitsModal, setOpenBenefitsModal] = useState(false);
  const [urlLimit12x, setUrlLimit12x] = useState('');
  const [base64Limit12x, setBase64Limit12x] = useState('');

  const urlContract = Endpoints.consult.userContract.replace(
    'PARAM_ID_PROPOSTA',
    propostaId,
  );

  const urlContractAgreement = Endpoints.consult.userContract.replace(
    'PARAM_ID_PROPOSTA',
    propostaIdConvenio,
  );

  const urlPlatinumContract = Endpoints.files.getPlatinumTerms.replace(
    'PARAM_ID_PROPOSTA',
    propostaId,
  );

  const [form, setForm] = useState<Form>({
    id: { name: 'id', value: '' },
    celular: { name: 'celular', value: '' },
    celular2: { name: 'celular2', value: '' },
    dataNascimento: { name: 'dataNascimento', value: '' },
    email: { name: 'email', value: '' },
    genero: { name: 'genero', value: '' },
    idClienteAutorizador: { name: 'idClienteAutorizador', value: '' },
    idUsuario: { name: 'idUsuario', value: '' },
    nome: { name: 'nome', value: '' },
    nomeSocial: { name: 'nomeSocial', value: '' },
    statusCliente: { name: 'statusCliente', value: '', status: '' },
    readmissao: false,
    tipoCanc: 'CANCELAMENTO_SOLICITACAO',

    endBairro: { name: 'endBairro', value: '' },
    endCep: { name: 'endCep', value: '' },
    endCidade: { name: 'endCidade', value: '' },
    endComplemento: { name: 'endComplemento', value: '' },
    endLogradouro: { name: 'endLogradouro', value: '' },
    endNumero: { name: 'endNumero', value: '' },
    endPais: { name: 'endPais', value: '' },
    endUf: { name: 'endUf', value: '' },
    origemOptin: { name: 'origemOptin', value: '' },
    dataCadastro: { name: 'dataCadastro', value: '' },
    quantidadeCobranca: 0,
    dataDecisao: { name: 'dataDecisao', value: '' },

    cardAnoExpiracao: { name: 'cardAnoExpiracao', value: '' },
    cardBandeira: { name: 'cardBandeira', value: '' },
    cardBloqueado: { name: 'cardBloqueado', value: '' },
    dataCancelamento: { name: 'dataCancelamento', value: '' },
    cardImpresso: { name: 'cardImpresso', value: '' },
    cardLimiteCredito: { name: 'cardLimiteCredito', value: '' },
    cardMesExpiracao: { name: 'cardMesExpiracao', value: '' },
    cardNomeTitular: { name: 'cardNomeTitular', value: '' },
    cardNumeroCartao: { name: 'cardNumeroCartao', value: '' },
    cardStatus: { name: 'cardStatus', value: '' },
    dataAtivacao: { name: 'dataAtivacao', value: '' },
    categoriaCartao: { name: 'categoriaCartao', value: '' },

    diaVencimento: { name: 'diaVencimento', value: '' },
    melhorDiaCompra: { name: 'melhorDiaCompra', value: '' },
    profissao: { name: 'profissao', value: '' },
    nomeEmpresa: { name: 'nomeEmpresa', value: '' },
    rendaInformada: { name: 'rendaInformada', value: '' },
    dataEmissao: { name: 'dataEmissao', value: '' },
    dataImpressao: { name: 'dataImpressao', value: '' },
    dataAprovacao: { name: 'dataAprovacao', value: '' },
    dataCorte: { name: 'dataCorte', value: '' },
    lojaNome: { name: 'lojaNome', value: '' },

    propDataCadastro: { name: 'propDataCadastro', value: '' },
    propDigitador: { name: 'propDigitador', value: '' },
    propLojaDoCadastro: { name: 'propLojaDoCadastro', value: '' },
    propOrigemDoCadastro: { name: 'propOrigemDoCadastro', value: '' },
    propStatus: { name: 'propStatus', value: '' },
    propNomeOperador: { name: 'propNomeOperador', value: '' },
    propStatusAprovacao: { name: 'propStatusAprovacao', value: '' },
    saldo: { name: 'saldo', value: '' },
    temaCartao: { name: 'saldo', value: '' },
    emCobranca: { name: 'saldo', value: '' },
    limiteSaque: { name: 'limiteSaque', value: '' },
    temCartaoCredito: false,
    temCarteiraDigital: false,
    temEmprestimo: false,
    nivel: '',
    quantidadeTotalPaga: 0,
    quantidadeTotalParcial: 0,
    quantidadeTotalParcelada: 0,
    pontuacao: 0,
    dataCampanha: '',
    carteira: {
      cartoes: [
        {
          bandeira: '',
          blackList: false,
          numeroCartao: '',
          principal: false,
          validado: false,
          id: '',
        },
      ],
      dataAdesao: '',
      dataPrimeiraCompra: '',
      nomeOperador: '',
    },
    tipoDoc: '',
  });

  const isSenff = form.propOrigemDoCadastro.value === 'SENFF';

  const [cardDeliveryTerm, setCardDeliveryTerm] = useState(
    {} as ICardDeliveryTermImage,
  );
  const inputCardDeliveryTerm = useRef(null);
  const inputUploadDocument = useRef(null);
  const isUserEditingCep = useRef(false);

  const [dialogSizeFileMessage, setDialogSizeFileMessage] = useState<boolean>(
    false,
  );
  // const [openDialogKYC, setOpenDialogKYC] = useState(false);
  const [sizeFile, setsizeFile] = useState<number>(0);
  const [benefitsDocuments, setBenefitsDocuments] = useState<any[]>([]);
  const [dataKYC, setDataKYC] = useState<IResponseInformationKYC>(
    {} as IResponseInformationKYC,
  );
  const [benefits, setBenefits] = useState([]);
  const [contractedWithdraw, setContractedWithdraw] = useState([]);
  const [fileBase64Withdraw, setFileBase64Withdraw] = useState('');
  const [dataBankingDataLoan, setDataBankingDataLoan] = useState<any>(null);

  const [modalUploadDocumentOpen, setModalUploadDocumentOpen] = useState(false);
  const [selectedDocumentFile, setSelectedDocumentFile] = useState(null);
  const [cardNumber, setCardNumber] = useState<string>();
  const { hasRole, hasAnyRole } = useUserRole();

  const [productTab, setProductTab] = useState<string>();

  const AuthValidatePassword = useApi<any>(
    Endpoints.account.validateUserPassword,
    ApiMethod.POST,
  );

  const api = useApi<ConsultUserDetailResponse>(
    Endpoints.consult.detailUserWallet.replace(
      'PARAM_CPF',
      location.state?.cpf,
    ),
    ApiMethod.GET,
  );

  const GETSearchClientCancel = useApi<ConsultclientCancelResponse>(
    Endpoints.consult.searchClientCancel.replace(
      'PARAM_CPF',
      location.state?.cpf,
    ),
    ApiMethod.GET,
  );

  const RequestUserContract = useApi(urlContract, ApiMethod.GET);

  const RequestUserPlatinumContract = useApi(
    urlPlatinumContract,
    ApiMethod.GET,
  );

  const RequestGetContractedWithdraw = useApi<IResponseContractWithdraw>(
    Endpoints.loan.getContractWithdraw.replace('PARAM_CPF', location.state.cpf),
    ApiMethod.GET,
  );

  const RequestGetLimit12xDocuments = useApi<any>(
    Endpoints.limits.getDocumentsLimit12x.replace(
      'PARAM_CPF',
      location.state.cpf,
    ),
    ApiMethod.GET,
  );

  const showOptionsRule = () => hasAnyRole(['ADM', 'SUP']);

  const disabledButtonSave = () => !hasAnyRole(['ADM', 'SUP', 'MDC']);

  const GetContractedBenefits = useApi<
    IResponseContractedsBenefits & IResponseDefaultError
  >(
    `${Endpoints.sales.getContractedBenefits.replace(
      'PARAM_ID_PROPOSTA',
      api?.data?.propostaId,
    )}`,
    ApiMethod.GET,
  );

  const RequestGetPDFContractedWithdraw = useApi<IResponseContractBase64>(
    Endpoints.loan.getContractWithdrawBase64.replace(
      'PARAM_ID',
      contractedWithdraw[0]?.id,
    ),
    ApiMethod.GET,
  );

  const RequestUserDocuments = useApi<UserDocumentsResponse>(
    `${Endpoints.consult.searchUserDocuments}${api?.data?.propostaId}`,
    ApiMethod.GET,
  );

  const documentosLimiteCredito =
    RequestUserDocuments.data?.documentosLimiteCredito?.filter(
      (documento) => !!documento?.arquivo,
    ) || [];

  const RequestUserDiverseDocuments = useApi(
    `${Endpoints.files.getSearchDocBase64.replace(
      'PARAM_ID_PROPOSTA',
      api?.data?.propostaId,
    )}`,
    ApiMethod.GET,
  );

  const RequestUserDocumentsCPF = useApi<IResponseGetUserDocuments>(
    Endpoints.consult.searchUserDocumentsCPF.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );

  const RequestUploadCardDeliveryTerm = useApi(
    Endpoints.files.uploadCardDeliveryTerm,
    ApiMethod.POST,
  );

  const RequestCardDeliveryTerm = useApi<{ termoEntregaBase64: string }>(
    Endpoints.consult.searchCardDeliveryTerm.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );

  const RequestSearchHistoricalBenefitProposal = useApi<any>(
    Endpoints.consult.getSearchHistoricalBenefitProposal.replace(
      'PARAM_CPF',
      state?.cpf,
    ),
    ApiMethod.GET,
  );

  const apiUserUpdate = useApi(Endpoints.consult.updateClient, ApiMethod.PUT);

  const POSTReferenceAPI = useApi<IProposal>(
    `${Endpoints.register.proposalReference}/${propostaId}`,
    ApiMethod.PUT,
  );

  const GETDocumentTypes = useApi<IDocumentTypes>(
    `${Endpoints.files.getDocumentTypes}`,
    ApiMethod.GET,
  );

  const GETProposalDocuments = useApi<IProposalDocuments>(
    `${Endpoints.files.getProposalDocuments.replace('PARAM_CPF', state?.cpf)}`,
    ApiMethod.GET,
  );

  const GETThemeCardsInfo = useApi<IThemeCard>(
    `${Endpoints.card.getClientCurrentCategory.replace(
      'PARAM_CPF',
      state?.cpf,
    )}`,
    ApiMethod.GET,
  );

  const POSTProposalDocuments = useApi(
    `${Endpoints.files.postProposalDocuments}`,
    ApiMethod.POST,
  );

  const DELETEProposalDocuments = useApi(
    `${Endpoints.files.deleteProposalDocument
      .replace('PARAM_CPF', state?.cpf)
      .replace('PARAM_FILENAME', selectedDocumentFile?.nome)}`,
    ApiMethod.DELETE,
  );

  const POSTGetDocumentBase64 = useApi<IResponseGetDocumentLink>(
    Endpoints.files.postGetDoc64,
    ApiMethod.POST,
  );

  const PutRemoveBlackList = useApi<any>(
    Endpoints.report.putRemoveBlackList
      .replace('PARAM_ID', cardNumber)
      .replace('PARAM_OP', localStorage.getItem('USER_ID')),
    ApiMethod.PUT,
  );

  const GetInformationKYCClient = useApi<IResponseInformationKYC>(
    Endpoints.loan.getInformationKYCClient.replace('PARAM_CPF', state?.cpf),
    ApiMethod.GET,
  );

  const DeleteRestritionKYC = useApi(
    Endpoints.loan.deleteRemoveRestritionKYC.replace('PARAM_CPF', state?.cpf),
    ApiMethod.DELETE,
  );

  const GetBankingDataLoan = useApi(
    Endpoints.loan.getBankingDataLoan.replace(
      'PARAM_ID_LOAN',
      api?.data?.idEmprestimo,
    ),
    ApiMethod.GET,
  );

  const GETSearchOCRProposal = useApi<ISearchOCRProposal>(
    Endpoints.consult.getSearchOCRProposal.replace(
      'PARAM_ID_PROPOSTA',
      api?.data?.propostaId,
    ),
    ApiMethod.GET,
  );

  const GetAddressByCep = useApi<any>(
    Endpoints.consult.getAddressByCep.replace(
      'PARAM_CEP',
      String(form.endCep.value || '').replace('-', ''),
    ),
    ApiMethod.GET,
  );

  const handleCEP = async () => {
    try {
      const response = await GetAddressByCep.callApi();
      if (response.status >= 200 && response.status < 300) {
        setForm((prev: any) => ({
          ...prev,
          endLogradouro: {
            ...prev.endLogradouro,
            value: response.data?.logradouro ?? '',
          },
          endBairro: { ...prev.endBairro, value: response.data?.bairro ?? '' },
          endCidade: {
            ...prev.endCidade,
            value: response.data?.localidade ?? '',
          },
          endUf: { ...prev.endUf, value: response.data?.uf ?? '' },
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getInformationKYCClient = async () => {
    try {
      const response = await GetInformationKYCClient.callApi();

      const { data, status } = response;

      if (status >= 200 && status < 300) {
        setDataKYC(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const removeRestritionKYC = useCallback(async () => {
    setOpenDialogKYC(false);

    try {
      const { status, mensagem } = await AuthValidatePassword.callApi({
        cpf: cpf?.unmasked,
        senha,
      });
      setSenha('');

      if (status >= 200 && status <= 300) {
        const response = await DeleteRestritionKYC.callApi();

        if (response.status >= 200) {
          setPopUpMessage('Restrição removida com sucesso');
          setOpenDialog(true);
        } else {
          setPopUpErrorMessage(response.mensagem);
          setPopUpError(true);
        }
      } else {
        setPopUpErrorMessage(mensagem);
        setPopUpError(true);
      }
    } catch (error) {
      setPopUpErrorMessage(error.mensagem);
      setPopUpError(true);
    }
  }, [senha]);

  const removeBlacklist = async () => {
    try {
      const response = await PutRemoveBlackList.callApi();
      if (response.status >= 200 && response.status < 300) {
        setDialogBlackListCards(false);
        window.location.reload();
      } else {
        setDialogBlackListRemoveError(true);
        setDialogText('Falha ao remover o cartão selecionado da blackList!');
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const getBankingDataLoan = async () => {
    try {
      const response = await GetBankingDataLoan.callApi();
      if (response.status >= 200 && response.status < 300) {
        setDataBankingDataLoan(response.data);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const getRequestHistoricalBenefit = async () => {
    try {
      const response = await RequestSearchHistoricalBenefitProposal.callApi();
      if (response.status >= 200 && response.status < 300) {
        setBenefitsDocuments(response.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const openCardDropDownAction = () => {
    if (
      state.produtos?.some(
        (item) =>
          item.tipoProduto === 'TEUCARD' && !isCartaoBloqueado(item?.status),
      )
    ) {
      setProductTab('TEUCARD');
    } else {
      setProductTab('CONVENIO');
    }
  };

  const handleProductTab = (product) => {
    setProductTab(product);
  };

  const goToHistoryLoanCelcoin = () => {
    history.push('/consult/user/history-loan', {
      cpf: state?.cpf,
    });
  };

  const handleCallbackUpdateInvoiceExpiration = async () => {
    await api.callApi();
  };

  useEffect(() => {
    api.callApi();
  }, []);

  async function getContractWithdraw() {
    try {
      const response = await RequestGetContractedWithdraw.callApi();
      if (response && Array.isArray(response.data)) {
        setContractedWithdraw(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async function getContractLimit12x() {
    try {
      const response = await RequestGetLimit12xDocuments.callApi();
      if (response.status === 200) {
        setUrlLimit12x(response.data.url);
        setBase64Limit12x(response.data.base64);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    const getInfoCards = async () => {
      try {
        const response = await GETThemeCardsInfo.callApi();
        if (response.status >= 200) {
          setCardInfos(response.data);
        }
      } catch (err) {
        console.error(err);
      }
    };
    getInfoCards();
  }, []);

  useEffect(() => {
    if (contractedWithdraw.length > 0) {
      const getContract = async () => {
        const response = await RequestGetPDFContractedWithdraw.callApi({});
        if (response.status >= 200) {
          const { contentPdf } = response.data;
          setFileBase64Withdraw(contentPdf);
        }
      };
      getContract();
    }
  }, [contractedWithdraw]);

  useEffect(() => {
    const fetchDocuments = async () => {
      if (state?.cpf) {
        try {
          const response = await RequestUserDocumentsCPF.callApi();
          setDocuments(response.data);
        } catch (error) {
          console.error('Erro ao buscar documentos:', error);
        }
      }
    };

    fetchDocuments();
  }, []);

  const handleLoadClientOCR = useCallback(async () => {
    if (!api?.data?.propostaId || GETSearchOCRProposal.loading) return;

    await GETSearchOCRProposal.callApi();
  }, [GETSearchOCRProposal, api?.data?.propostaId]);

  const handleLoadClientDocuments = useCallback(async () => {
    // para nao carregar duas vezes ao abrir e fechar o dropdown
    if (GETDocumentTypes.data) return;

    const [proposalDocuments, userDocumentsCpf] = await Promise.all([
      GETProposalDocuments.callApi(),
      GETDocumentTypes.callApi(),
    ]);

    if (form.temCartaoCredito) {
      const [
        contractedBenefits,
        cardDeliveryTerm,
        diverseDocuments,
      ] = await Promise.all([
        RequestCardDeliveryTerm.callApi(),
        RequestUserDocuments.callApi(),
        RequestUserDiverseDocuments.callApi(),
        getRequestHistoricalBenefit(),
        getContractWithdraw(),
        getContractLimit12x(),
      ]);

      const { termoEntregaBase64 } =
        (cardDeliveryTerm?.data as { termoEntregaBase64?: string }) ?? {};

      if (diverseDocuments.data && Array.isArray(diverseDocuments.data)) {
        setDiverseDocuments(
          diverseDocuments.data.map((e) => ({ ...e, nome: e.filename })) ?? [],
        );
      }
      setBenefits((contractedBenefits?.data as any)?.beneficios ?? []);

      isImageBase64(`data:image/png;base64, ${termoEntregaBase64}`).then(
        (data) => {
          setCardDeliveryTerm((prev) => ({
            ...prev,
            term: {
              front:
                !!termoEntregaBase64 &&
                `${data ? 'data:image/png;base64' : ''}, ${termoEntregaBase64}`,
              tipo: data ? 'image' : 'pdf',
            },
          }));
        },
      );
    }

    if (proposalDocuments.data) {
      setProposalDocuments(proposalDocuments?.data?.documentos ?? []);
    }
    if (documents) {
      const { documentoEndereco, documentoRenda } = documents;
      isImageBase64(`data:image/png;base64, ${documentoEndereco}`).then(
        (data) => {
          setDocumentsImage((prev) => ({
            ...prev,
            address: {
              front:
                !!documentoEndereco &&
                `${data ? 'data:image/png;base64' : ''}, ${documentoEndereco}`,
              tipo: data ? 'image' : 'pdf',
              nome: 'Comprovante de residência',
            },
          }));
        },
      );
      isImageBase64(`data:image/png;base64, ${documentoRenda}`).then((data) => {
        setDocumentsImage((prev) => ({
          ...prev,
          income: {
            front:
              !!documentoRenda &&
              `${data ? 'data:image/png;base64' : ''}, ${documentoRenda}`,
            tipo: data ? 'image' : 'pdf',
            nome: 'Comprovante de renda',
          },
        }));
      });
    }
  }, [
    GETProposalDocuments,
    RequestUserDocuments,
    RequestUserDocumentsCPF,
    GETDocumentTypes,
    RequestSearchHistoricalBenefitProposal,
    GetContractedBenefits,
    RequestCardDeliveryTerm,
    RequestGetLimit12xDocuments,
    form.temCartaoCredito,
    api.data,
  ]);

  useEffect(() => {
    if (!api.loading && api.data) {
      loadData();
    }
  }, [api.loading]);

  useEffect(() => {
    const rawCep = String(form.endCep.value || '').replace(/\D/g, '');
    if (rawCep && rawCep.length === 8) {
      if (!isUserEditingCep.current) {
        isUserEditingCep.current = true;
        return;
      }
      handleCEP();
    }
  }, [form.endCep.value]);

  const goBack = () => history.goBack();

  const handleValidation = () => {
    let errors = [
      emailValidator(String(form.email.value)?.trim()),
      dateValidator(
        String(form.dataNascimento.value),
        ValidatorsNames.dateBirth,
      ),
      phoneValidator(String(form.celular.value)),
      socialNameValidator(
        String(form.nomeSocial.value),
        String(form.nome.value),
      ),
    ].reduce((memo, el) => ({ ...memo, ...el }), {});

    if (String(form.celular2.value).length) {
      errors = {
        ...errors,
        ...phoneValidator(String(form.celular2.value), ValidatorsNames.phone2),
      };
    }

    if (errors?.socialName) {
      setDialogIsOpenError(true);
      setDialogText(String(errors?.socialName));
      return;
    }

    setErrors(errors);
    const hasErrors =
      Object.values(errors).filter((a) => a !== null).length > 0;
    return hasErrors;
  };

  const [email, setEmail] = useState('');

  const updateClient = async () => {
    const notValid = handleValidation();
    if (notValid) return;

    const endereco: Endereco = {
      bairro: String(form.endBairro.value),
      cep: String(form.endCep.unmasked),
      cidade: String(form.endCidade.value),
      complemento: String(form.endComplemento.value),
      logradouro: String(form.endLogradouro.value),
      numero: String(form.endNumero.value),
      pais: String(form.endPais.value),
      uf: String(form.endUf.value),
    };

    const payload: UpdateUserPayload = {
      celular: String(form.celular.unmasked),
      celular2: String(form.celular2?.unmasked),
      email: String(form.email.value)?.trim(),
      idCliente: String(form.id.value),
      nomeSocial: String(form?.nomeSocial?.value),
      endereco,
      profissao: String(form.profissao.value),
      nomeEmpresa: String(form.nomeEmpresa.value),
      dataNascimento: transformInGlobalDate(String(form.dataNascimento.value)),
      genero: String(form.genero.value),
      rendaInformada: Masks.currencyUnmasked(String(form.rendaInformada.value)),
    };

    const response = await apiUserUpdate.callApi(payload);

    if (response.status === 200) {
      setDialogText('Dados atualizado com sucesso!');
    } else {
      setDialogText(response?.mensagem || 'Falha ao atualizar os dados!');
    }
    setDialogIsOpen(true);
  };

  const [modalCanceledBenefit, setModalCanceledBenefit] = useState(false);
  const [benefitContractLinks, setBenefitContractLinks] = useState({
    linkContrato: '',
    linkContratoCancelado: '',
  });
  const handleOpenModalCanceledBenefit = (
    linkContrato,
    linkContratoCancelamento,
  ) => {
    setBenefitContractLinks({
      linkContrato,
      linkContratoCancelado: linkContratoCancelamento,
    });
    setModalCanceledBenefit(true);
  };

  function findLastCardByType(
    cards: Cartao[],
    cardType: string,
  ): Cartao | undefined {
    return cards.findLast(
      (c) => c.tipoCartao.toLowerCase() === cardType.toLowerCase(),
    );
  }

  const loadData = () => {
    const data = api.data as ConsultUserDetailResponse;

    let cartao = {} as Cartao;

    if (data.cartaoAtual && data?.cartoes?.length > 0) {
      data.cartoes.forEach((c) => {
        cartao = {
          anoExpiracao: c.anoExpiracao || '',
          bandeira: c.bandeira || '',
          bloqueado: c.bloqueado || false,
          impresso: c.impresso || false,
          limiteCredito: c.limiteCredito || 0,
          mesExpiracao: c.mesExpiracao || '',
          nomeTitular: c.nomeTitular || '',
          numeroCartao: c.numeroCartao || '',
          status: c.status || '',
          dataAtivacao: c.dataAtivacao || '',
          origemOptin: c.origemOptin || '',
          optinTermoDeUso: c.optinTermoDeUso,
          checkWhatsApp: c.checkWhatsApp,
          propostaId: c.propostaId || '',
          tipoCartao: c.tipoCartao || '',
        };
      });
    }

    const cartaoConvenio = findLastCardByType(data.cartoes, 'CONVENIO');
    const cartaoTeuCard = findLastCardByType(data.cartoes, 'TEUCARD');

    if (cartaoConvenio) {
      setPropostaIdConvenio(cartaoConvenio?.propostaId);
    }

    if (cartaoTeuCard) {
      setPropostaId(cartaoTeuCard?.propostaId);
    }

    const dateTransformed = transformInNormalDate(
      String(data?.dataNascimento) || '',
    );

    const cep = Masks.cepMask(data.endereco?.cep);
    const telefone = Masks.phoneMask(Masks.phoneUnmask(data.celular));
    const telefone2 = Masks.phoneMask(Masks.phoneUnmask(data.celular2));
    const dtNascimento = dateTransformed;

    const dtCancelamento = transformInNormalDate(
      data?.dataCancelamento?.split('T')[0],
    );

    const obj: Form = {
      ...form,
      id: {
        ...form.celular,
        value: data.id,
        unmasked: data.id,
      },
      celular: {
        ...form.celular,
        value: telefone.masked,
        unmasked: telefone.unmasked,
      },
      celular2: {
        ...form.celular2,
        value: telefone2.masked,
        unmasked: telefone2.unmasked,
      },
      dataNascimento: {
        ...form.dataNascimento,
        value: dtNascimento.masked,
        unmasked: dtNascimento.unmasked,
      },
      email: { ...form.email, value: data.email },
      genero: { ...form.genero, value: data.genero },
      idClienteAutorizador: {
        ...form.idClienteAutorizador,
        value: data.idClienteAutorizador,
      },
      idUsuario: { ...form.idUsuario, value: data.idUsuario },
      nome: { ...form.nome, value: data.nome },
      nomeSocial: { ...form.nomeSocial, value: data.nomeSocial },
      endBairro: { ...form.endBairro, value: data.endereco?.bairro },
      endCep: {
        ...form.endCep,
        value: cep.masked,
        unmasked: cep.unmasked,
      },
      endCidade: { ...form.endCidade, value: data.endereco?.cidade },
      endComplemento: {
        ...form.endComplemento,
        value: data.endereco?.complemento,
      },
      endLogradouro: {
        ...form.endLogradouro,
        value: data.endereco?.logradouro,
      },
      endNumero: { ...form.endNumero, value: data.endereco?.numero },
      endPais: { ...form.endPais, value: data.endereco?.pais },
      endUf: { ...form.endUf, value: data.endereco?.uf },

      aposentadoPensionista: data.aposentadoPensionista,

      statusCliente: {
        ...form.statusCliente,
        value: data.cartaoAtual?.motivoBloqueio?.descricao,
        status: data.cartaoAtual?.motivoBloqueio?.status,
      },
      dataCancelamento: {
        ...form.dataCancelamento,
        value: dtCancelamento.masked,
        unmasked: dtCancelamento.unmasked,
      },
      readmissao: data?.readmissao,
      cardAnoExpiracao: {
        ...form.cardAnoExpiracao,
        value: cartao.anoExpiracao,
      },
      cardBandeira: { ...form.cardBandeira, value: cartao.bandeira },
      cardBloqueado: { ...form.cardBloqueado, value: String(cartao.bloqueado) },
      cardImpresso: { ...form.cardImpresso, value: String(cartao.impresso) },
      cardLimiteCredito: {
        ...form.cardLimiteCredito,
        value: String(cartao.limiteCredito),
      },
      cardMesExpiracao: {
        ...form.cardMesExpiracao,
        value: cartao.mesExpiracao,
      },
      cardNomeTitular: { ...form.cardNomeTitular, value: cartao.nomeTitular },
      cardNumeroCartao: {
        ...form.cardNumeroCartao,
        value: cartao.numeroCartao,
      },
      checkWhatsapp: cartao.checkWhatsApp,
      optinTermoDeUso: cartao.optinTermoDeUso,
      cardStatus: { ...form.cardStatus, value: cartao.status },
      origemOptin: { ...form.origemOptin, value: cartao.origemOptin },
      diaVencimento: {
        ...form.diaVencimento,
        value: data.diaVencimento?.substring(0, 2),
      },
      melhorDiaCompra: { ...form.melhorDiaCompra, value: data.melhorDiaCompra },
      profissao: { ...form.profissao, value: data.profissao },
      nomeEmpresa: { ...form.nomeEmpresa, value: data.nomeEmpresa },
      rendaInformada: {
        ...form.rendaInformada,
        value: Masks.currencyMask(data.rendaInformada),
      },

      dataCadastro: { ...form.dataCadastro, value: data.dataCadastro },
      dataEmissao: { ...form.dataEmissao, value: data.dataEmissao },
      dataImpressao: {
        ...form.dataImpressao,
        value: data.cartaoAtual?.dataImpressao,
      },
      dataAprovacao: {
        ...form.dataAprovacao,
        value: data.proposta?.dataAprovacao,
      },

      dataAtivacao: {
        ...form.dataAtivacao,
        value: cartao.dataAtivacao,
      },

      dataCorte: {
        ...form.dataCorte,
        value: data.dataFechamento,
      },

      lojaNome: { ...form.lojaNome, value: data.lojaNome },
      propDataCadastro: {
        ...form.propDataCadastro,
        value: data.proposta?.dataCadastro,
      },
      propDigitador: { ...form.propDigitador, value: data.atendente?.nome },
      propLojaDoCadastro: {
        ...form.propLojaDoCadastro,
        value: data.proposta?.lojaDoCadastro,
      },
      propOrigemDoCadastro: {
        ...form.propOrigemDoCadastro,
        value: data.proposta?.origemDoCadastro,
      },
      propStatus: { ...form.propStatus, value: data.proposta?.status },
      propStatusAprovacao: {
        ...form.propStatusAprovacao,
        value: data?.proposta?.statusAprovacao,
      },
      propNomeOperador: {
        ...form.propNomeOperador,
        value: data?.proposta?.operador?.nome,
      },
      emCobranca: { ...form.saldo, value: data.diasAtraso },
      temCartaoCredito: state.produtos?.some(
        (item) =>
          (item.tipoProduto === 'TEUCARD' &&
            !isCartaoBloqueado(item?.status)) ||
          item.tipoProduto === 'CONVENIO',
      ),
      temCarteiraDigital: state.produtos?.some(
        (item) => item.tipoProduto === 'CARTEIRA_DIGITAL',
      ),
      temEmprestimo: state.produtos?.some(
        (item) => item.tipoProduto === 'EMPRESTIMO',
      ),

      nivel: data?.nivel,
      quantidadeTotalPaga: data?.quantidadeTotalPaga,
      quantidadeTotalParcial: data?.quantidadeTotalParcial,
      quantidadeTotalParcelada: data?.quantidadeTotalParcelada,
      quantidadeCobranca: data?.quantidadeCobranca,
      dataDecisao: { ...form.dataDecisao, value: data.dataDecisao },
      pontuacao: data?.pontuacao,
      dataCampanha: data?.dataCampanha,
      categoriaCartao: { ...form.categoriaCartao, value: data.categoriaCartao },

      carteira: {
        cartoes: data?.carteira?.cartoes,
        dataAdesao: data?.carteira?.dataAdesao,
        dataPrimeiraCompra: data?.carteira?.dataPrimeiraCompra,
        nomeOperador: data?.carteira?.nomeOperador,
      },
    };

    setEmail(data.email);
    setForm(obj);

    if (data.proposta?.contatos?.length) {
      data.proposta?.contatos?.forEach((item, index) => {
        if (index === 0) {
          setAddReference({
            id: item.id,
            comentarioRef: item.comentario,
            nomeRefe: item.nome,
            phoneRefe: {
              masked: Masks.phoneMask(item.telefone).masked,
              unmasked: item.telefone,
            },
            relacaoCli: item.relacao,
          });
        } else {
          setAddReferenceII({
            id: item.id,
            comentarioRef: item.comentario,
            nomeRefe: item.nome,
            phoneRefe: {
              masked: Masks.phoneMask(item.telefone).masked,
              unmasked: item.telefone,
            },
            relacaoCli: item.relacao,
          });
        }
      });
    }
  };

  const setReferenceAPI = async () => {
    const payloadRefI = {
      idContato: addReference.id ? addReference.id : undefined,
      comentario: addReference.comentarioRef,
      nome: addReference.nomeRefe,
      relacao: addReference.relacaoCli,
      telefone: addReference.phoneRefe?.unmasked,
    };

    const payloadRefII = {
      idContato: addReferenceII.id ? addReferenceII.id : undefined,
      comentario: addReferenceII.comentarioRef,
      nome: addReferenceII.nomeRefe,
      relacao: addReferenceII.relacaoCli,
      telefone: addReferenceII.phoneRefe?.unmasked,
    };

    if (payloadRefI.nome || payloadRefI.relacao || payloadRefI.telefone) {
      await POSTReferenceAPI.callApi([payloadRefI]);
    }

    if (payloadRefII.nome || payloadRefII.relacao || payloadRefII.telefone) {
      await POSTReferenceAPI.callApi([payloadRefII]);
    }
  };

  const addReferenceAPI = async () => {
    await setReferenceAPI();

    setDialogIsOpenSaveR(false);

    setDialogMessage('Referências alterada com sucesso!');
    setDialogMessageStatus(true);
  };

  const handleChangeReference = ({ target: { name, value } }) => {
    setAddReference({
      ...addReference,
      [name]: value,
    });
  };

  const handleSelectReference = (value, name) => {
    setAddReference({
      ...addReference,
      [name]: value,
    });
  };

  const handleChangeReferenceII = ({ target: { name, value } }) => {
    setAddReferenceII({
      ...addReferenceII,
      [name]: value,
    });
  };

  const handleSelectReferenceII = (value, name) => {
    setAddReferenceII({
      ...addReferenceII,
      [name]: value,
    });
  };

  const handleCallbackClickDuplicateCardReference = async () => {
    await api.callApi();
  };

  const handleCallbackBlockCard = async () => {
    await api.callApi();
  };

  const onClickDocClientCancel = useCallback(async () => {
    const responseContract = await GETSearchClientCancel.callApi();
    if (responseContract.status >= 300) {
      setDialogDocumentOpen(true);
      setDialogDocumentMessage('Ops! Não foi possível buscar os documentos.');
    }
  }, [GETSearchClientCancel]);

  const onClickDownloadContract = async () => {
    const responseContract = await RequestUserContract.callApi();
    if (responseContract.status === 200) {
      downloadReadableStream(
        responseContract.response,
        `${form.nome?.value} - ${Masks.cpfMask(location.state?.cpf).masked}`,
      );
    }
  };

  const onClickDownloadPlatinumContract = async () => {
    const responseContract = await RequestUserPlatinumContract.callApi();
    if (responseContract.status === 200) {
      downloadReadableStream(
        responseContract.response,
        `${form.nome?.value} - ${Masks.cpfMask(location.state?.cpf).masked}`,
      );
    }
  };

  const onClickDownloadTerms12x = async () => {
    const response = await RequestGetLimit12xDocuments.callApi();
    if (response.status === 200) {
      downloadReadableStream(response.data.urlTermoAnaliseCredito, ``);
    }
  };

  const onClickViewPlatinumContract = async () => {
    const responseContract = await RequestUserPlatinumContract.callApi();
    if (responseContract.status === 200) {
      openInNewTab(responseContract.response);
    }
  };

  const onClickDownloadWavFile = async (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.click();
  };
  const isImageBase64 = (str) =>
    new Promise((resolve) => {
      const img = new Image();
      img.addEventListener('error', () => resolve(false));
      img.addEventListener('load', () => resolve(/^data:.*;base64,/.test(str)));
      img.src = str;
    });

  const fileToBase64 = async (f: Blob): Promise<string | ArrayBuffer> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => reject(e);
    });

  const triggerFileCardDeliveryTermFrontPicker = () =>
    inputCardDeliveryTerm.current?.click();

  const downloadBase64Image = (url: string, name: string) => {
    const a = document.createElement('a');
    a.href = `data:image/png;base64, ${url}`;
    a.download = `${name}.png`;
    a.click();
  };

  const downloadLimitReceipts = () => {
    if (documentosLimiteCredito.length > 0) {
      documentosLimiteCredito.forEach((documento, index) => {
        if (documento.arquivo) {
          downloadBase64Image(
            documento.arquivo,
            `comprovanteLimiteCredito ${form.nome.value} ${index + 1}`,
          );
        }
      });
      return;
    }

    if (RequestUserDocuments.data?.documentoLimiteCredito) {
      downloadBase64Image(
        RequestUserDocuments.data.documentoLimiteCredito,
        `comprovanteLimiteCredito ${form.nome.value}`,
      );
    }
  };

  const openLimitReceipts = () => {
    if (documentosLimiteCredito.length === 0) {
      if (RequestUserDocuments.data?.documentoLimiteCredito) {
        handleOpenImageInNewTab(
          `data:image/png;base64, ${RequestUserDocuments.data.documentoLimiteCredito}`,
        );
      }
      return;
    }

    const receiptWindow = window.open('', '_blank');
    if (!receiptWindow) return;

    receiptWindow.opener = null;
    receiptWindow.document.title = 'Comprovantes de limite de credito';
    receiptWindow.document.body.style.margin = '0';
    receiptWindow.document.body.style.padding = '24px';
    receiptWindow.document.body.style.backgroundColor = '#f5f5f5';
    receiptWindow.document.body.style.fontFamily = 'Arial, sans-serif';
    receiptWindow.document.body.style.display = 'grid';
    receiptWindow.document.body.style.gridTemplateColumns =
      'repeat(auto-fit, minmax(320px, 1fr))';
    receiptWindow.document.body.style.gap = '24px';
    receiptWindow.document.body.style.alignItems = 'start';

    documentosLimiteCredito.forEach((documento, index) => {
      if (!documento.arquivo) return;

      const container = receiptWindow.document.createElement('section');
      const title = receiptWindow.document.createElement('h2');
      const image = receiptWindow.document.createElement('img');

      title.textContent = `Comprovante ${index + 1}`;
      title.style.fontSize = '18px';
      title.style.margin = '0 0 12px';

      image.src = `data:image/png;base64, ${documento.arquivo}`;
      image.alt = `Comprovante de limite ${index + 1}`;
      image.style.display = 'block';
      image.style.width = '100%';
      image.style.maxWidth = '100%';
      image.style.height = 'auto';
      image.style.maxHeight = '70vh';
      image.style.margin = '0 auto';
      image.style.objectFit = 'contain';

      container.style.padding = '20px';
      container.style.backgroundColor = '#fff';
      container.style.borderRadius = '8px';
      container.style.boxSizing = 'border-box';
      container.append(title, image);
      receiptWindow.document.body.appendChild(container);
    });
  };

  const downloadCardContract = async (url: string, filename: string) => {
    try {
      const response = await fetch(url, { method: 'GET' });
      const blob = await response.blob();

      const fileURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = `${filename || 'contrato'}.pdf`;
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(fileURL);
    } catch (error) {
      setDialogDocumentOpen(true);
      setDialogDocumentMessage('Ops! Não foi possível baixar o contrato.');
    }
  };

  const handleUploadFile = async () => {
    const base64 = (await fileToBase64(selectedDocumentFile)) as string;

    const { status, mensagem } = await POSTProposalDocuments.callApi({
      arquivo: base64.split(',')[1],
      idTipoDocumento: form.tipoDoc,
      cpf: Masks.cpfMask(location.state?.cpf).unmasked,
      mimeType: selectedDocumentFile.type,
    });
    setModalUploadDocumentOpen(false);
    if (status >= 200 && status <= 300) {
      setDialogDocumentOpen(true);
      setDialogDocumentMessage('Documento salvo com sucesso!');
      setSelectedDocumentFile(null);
    } else if (status === 413) {
      setDialogDocumentOpen(true);
      setDialogDocumentMessage(
        'Upload não realizado! O tamanho máximo é de 10Mb.',
      );
      setSelectedDocumentFile(null);
    } else {
      setDialogDocumentOpen(true);
      setDialogDocumentMessage(
        mensagem ?? 'Houve um erro ao salvar documento!',
      );
      setSelectedDocumentFile(null);
    }
  };

  const fileSelected = async <
    T extends keyof ICardDeliveryTermImage,
    U extends keyof ICardDeliveryTermImage[T]
  >(
    e: React.ChangeEvent<HTMLInputElement>,
    key: T,
    side: U,
  ) => {
    const fileValue = e.target.files[0];

    if (fileValue.size > 1000000) {
      setDialogSizeFileMessage(true);
      setsizeFile(fileValue.size);
    } else if (fileValue) {
      const base64 = (await fileToBase64(fileValue)) as string;
      try {
        await RequestUploadCardDeliveryTerm.callApi({
          file: base64.split(',')[1],
          cpf: Masks.cpfMask(location.state?.cpf).unmasked,
        });

        isImageBase64(base64).then((data) => {
          setCardDeliveryTerm((prev) => ({
            ...prev,
            [key]: {
              ...prev[key],
              [side]: base64,
              tipo: data ? 'image' : 'pdf',
            },
          }));
        });
      } catch (err) {
        console.error(err.message);
      }
    }
  };

  const handleDeleteFile = async () => {
    const { status, mensagem } = await DELETEProposalDocuments.callApi();
    setDialogDeleteDocumentOpen(false);
    if (status >= 200 && status <= 300) {
      setDialogMessage('Documento excluído com sucesso!');
      setDialogMessageStatus(true);
      await GETProposalDocuments.callApi().then((data) => {
        setProposalDocuments(data?.data?.documentos);
      });
    } else {
      setDialogMessage(mensagem ?? 'Houve um erro ao excluir documento!');
      setDialogMessageStatus(true);
    }
  };

  const downloadBase64File = (base64Data: string, filename: string) => {
    const byteCharacters = atob(
      base64Data.replace(/^data:application\/pdf;base64,/, ''),
    );
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(link.href);
  };

  const handleDownloadDocument = useCallback(async (e) => {
    const { status, data, mensagem } = await POSTGetDocumentBase64.callApi({
      cpf: state.cpf,
      nomeArquivo: e?.nome,
    });
    if (status >= 200 && status <= 300) {
      switch (data?.mimeType) {
        case 'image/jpg':
          handleOpenImageInNewTab(`data:image/jpg;base64, ${data?.base64}`);
          return;
        case 'image/png':
          handleOpenImageInNewTab(`data:image/png;base64, ${data?.base64}`);
          return;
        case 'image/jpeg':
          handleOpenImageInNewTab(`data:image/jpeg;base64, ${data?.base64}`);
          return;
        default:
          handleOpenPdfInNewTab(data?.base64);
      }
    } else {
      setDialogMessage(mensagem ?? 'Houve um erro ao visualizar documento!');
      setDialogMessageStatus(true);
    }
  }, []);

  const handleOpenImageInNewTab = (url: string) => {
    const w = window.open('');
    const image = new Image();
    image.src = url;
    setTimeout(() => {
      w?.document && w?.document.write(image.outerHTML);
    }, 0);
  };

  function base64ToBlob(base64, type = 'application/octet-stream') {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type });
  }
  const handleOpenPdfInNewTab = (base64: string) => {
    const blob = base64ToBlob(base64, 'application/pdf');
    const url = URL.createObjectURL(blob);
    const pdfWindow = window.open('');
    pdfWindow.document.write(
      "<iframe width='100%' height='100%' src='" + url + "'></iframe>",
    );
  };

  const handlePictureBiometric = (): string => {
    if (documents?.fotoCertiface) {
      return `data:image/jpeg;base64, ${documents?.fotoCertiface}`;
    } else if (documents?.urlFotoUnico) {
      return documents?.urlFotoUnico;
    } else {
      return icons.userAvatar;
    }
  };

  const handleGetOtherDocuments = () => {
    GETProposalDocuments.callApi().then((data) => {
      setProposalDocuments(data?.data?.documentos);
    });
  };

  const hasExperienceCancellation = useMemo(
    () =>
      location.state?.produtos?.some(
        (item) =>
          item?.status === 'CANCELAMENTO_EXPERIENCIA' ||
          item?.status === 'CANCELAMENTO_SOLICITACAO',
      ) ?? false,
    [location.state?.produtos],
  );

  const handleOpenInvoiceDetailFromCancel = useCallback(
    (invoice: CancelInvoiceItem) => {
      const [mesReferencia = '', anoReferencia = ''] = String(
        invoice?.dataReferencia || '',
      ).split('/');

      history.push('/invoice/detail', {
        cpf: state?.cpf,
        numeroCartao: invoice?.numeroCartao,
        dataVencimento: invoice?.dataVencimento,
        idFatura: invoice?.id,
        faturaId: invoice?.id_fatura,
        mesReferencia,
        anoReferencia,
        status: invoice?.status,
        linhaDigitavel: '',
        allData: [],
      });
    },
    [history, state?.cpf],
  );

  const isOpeningDocumentsCollapseRef = useRef(false);
  const isOpeningDocumentsCancelCollapseRef = useRef(false);

  const handleOpenDocumentsCollapse = useCallback(async () => {
    if (
      isOpeningDocumentsCollapseRef.current ||
      GETDocumentTypes.loading ||
      GETProposalDocuments.loading
    ) {
      return;
    }

    isOpeningDocumentsCollapseRef.current = true;
    try {
      await handleLoadClientDocuments();
    } finally {
      isOpeningDocumentsCollapseRef.current = false;
    }
  }, [
    handleLoadClientDocuments,
    GETDocumentTypes.loading,
    GETProposalDocuments.loading,
  ]);

  const handleOpenDocumentsCancelCollapse = useCallback(async () => {
    if (
      isOpeningDocumentsCancelCollapseRef.current ||
      GETSearchClientCancel.loading ||
      GETSearchClientCancel.data
    ) {
      return;
    }

    isOpeningDocumentsCancelCollapseRef.current = true;
    try {
      await onClickDocClientCancel();
    } finally {
      isOpeningDocumentsCancelCollapseRef.current = false;
    }
  }, [
    GETSearchClientCancel.loading,
    GETSearchClientCancel.data,
    onClickDocClientCancel,
  ]);

  const dataDocuments = useMemo(
    () => [
      {
        title: 'Documentos Pessoais',
        hidden: !form.temCartaoCredito,
        data: [
          {
            disabled: {
              download: !RequestUserDocuments.data?.documentoFrente,
              view: !RequestUserDocuments.data?.documentoFrente,
            },
            nome: 'CNH ou Carteira de Identidade (Frente)',
            onClickDownload: () =>
              downloadBase64Image(
                RequestUserDocuments.data?.documentoFrente,
                `documentoFrente ${form.nome.value}`,
              ),
            onClickView: () =>
              handleOpenImageInNewTab(
                `data:image/png;base64, ${RequestUserDocuments.data?.documentoFrente}`,
              ),
          },
          {
            disabled: {
              download: !RequestUserDocuments.data?.documentoVerso,
              view: !RequestUserDocuments.data?.documentoVerso,
            },
            nome: 'CNH ou Carteira de Identidade (Verso)',
            onClickDownload: () =>
              downloadBase64Image(
                RequestUserDocuments.data?.documentoVerso,
                `documentoVerso ${form.nome.value}`,
              ),
            onClickView: () =>
              handleOpenImageInNewTab(
                `data:image/png;base64, ${RequestUserDocuments.data?.documentoVerso}`,
              ),
          },
          {
            disabled: {
              download: !RequestUserDocuments.data?.fotoCertiface,
              view: !RequestUserDocuments.data?.fotoCertiface,
            },
            nome: 'Certiface',
            onClickDownload: () =>
              downloadBase64Image(
                RequestUserDocuments.data?.fotoCertiface,
                `fotoCertiface ${form.nome.value}`,
              ),
            onClickView: () =>
              handleOpenImageInNewTab(
                `data:image/png;base64, ${RequestUserDocuments.data?.fotoCertiface}`,
              ),
          },
          {
            disabled: {
              download: !documentsImage.income?.front,
              view: !documentsImage.income?.front,
            },
            nome: 'Comprovante de renda',
            onClickDownload: () =>
              documentsImage.income?.tipo === 'image' &&
              downloadBase64Image(
                documentsImage.income?.front.replace(
                  'data:image/png;base64, ',
                  '',
                ),
                `comprovanteDeRenda ${form.nome.value}`,
              ),
            onClickView:
              documentsImage.income?.tipo === 'image'
                ? () => handleOpenImageInNewTab(documentsImage.income?.front)
                : () => handleOpenPdfInNewTab(documentsImage.income?.front),
          },
          {
            disabled: {
              download: !documentsImage.address?.front,
              view: !documentsImage.address?.front,
            },
            nome: 'Comprovante de Residência',
            onClickDownload: () =>
              documentsImage.address?.tipo === 'image' &&
              downloadBase64Image(
                documentsImage.address?.front.replace(
                  'data:image/png;base64, ',
                  '',
                ),
                `comprovanteDeResidencia ${form.nome.value}`,
              ),
            onClickView:
              documentsImage.address?.tipo === 'image'
                ? () => handleOpenImageInNewTab(documentsImage.address?.front)
                : () => handleOpenPdfInNewTab(documentsImage.address?.front),
          },
        ],
      },
      {
        title: 'Documentos Pessoais Carteira Digital',
        hidden: !form.temCarteiraDigital,
        data: [
          {
            disabled: {
              download: !RequestUserDocumentsCPF.data?.documentoFrente,
              view: !RequestUserDocumentsCPF.data?.documentoFrente,
            },
            nome: 'CNH ou Carteira de Identidade (Frente)',
            onClickDownload: () =>
              downloadBase64Image(
                RequestUserDocumentsCPF.data?.documentoFrente,
                `documentoFrente ${form.nome.value}`,
              ),
            onClickView: () =>
              handleOpenImageInNewTab(
                `data:image/png;base64, ${RequestUserDocumentsCPF.data?.documentoFrente}`,
              ),
          },
          {
            disabled: {
              download: !RequestUserDocumentsCPF.data?.documentoVerso,
              view: !RequestUserDocumentsCPF.data?.documentoVerso,
            },
            nome: 'CNH ou Carteira de Identidade (Verso)',
            onClickDownload: () =>
              downloadBase64Image(
                RequestUserDocumentsCPF.data?.documentoVerso,
                `documentoVerso ${form.nome.value}`,
              ),
            onClickView: () =>
              handleOpenImageInNewTab(
                `data:image/png;base64, ${RequestUserDocumentsCPF.data?.documentoVerso}`,
              ),
          },
          {
            disabled: {
              download: !RequestUserDocumentsCPF.data?.fotoCertiface,
              view: !RequestUserDocumentsCPF.data?.fotoCertiface,
            },
            nome: 'Certiface',
            onClickDownload: () =>
              downloadBase64Image(
                RequestUserDocumentsCPF.data?.fotoCertiface,
                `fotoCertiface ${form.nome.value}`,
              ),
            onClickView: () =>
              handleOpenImageInNewTab(
                `data:image/png;base64, ${RequestUserDocumentsCPF.data?.fotoCertiface}`,
              ),
          },
        ],
      },
      {
        hidden: !form.temCartaoCredito,
        title: 'Documentos da proposta',
        data: [
          {
            disabled: {
              download: !propostaId,
              view: !propostaId,
            },
            nome: 'Contrato cartão de crédito',
            onClickDownload: () =>
              downloadCardContract(
                urlContract,
                `CONTRATO_TEUCARD_${form.nome?.value}_${
                  Masks.cpfMask(location.state?.cpf).masked
                }`,
              ),
            onClickView: () => window.open(urlContract),
          },
          {
            disabled: {
              download: !propostaIdConvenio,
              view: !propostaIdConvenio,
            },
            nome: 'Contrato cartão convênio',
            onClickDownload: () =>
              downloadCardContract(
                urlContractAgreement,
                `CONTRATO_CONVENIO_${form.nome?.value}_${
                  Masks.cpfMask(location.state?.cpf).masked
                }`,
              ),
            onClickView: () => window.open(urlContractAgreement),
          },
          {
            disabled: {
              download: !cardDeliveryTerm.term?.front,
              view: !cardDeliveryTerm.term?.front,
              upload: false,
            },
            nome: 'Termo de entrega do cartão',
            onClickDownload: () =>
              downloadBase64Image(
                cardDeliveryTerm.term?.front.replace(
                  'data:image/png;base64, ',
                  '',
                ),
                `termoEntregaCartao ${form.nome.value}`,
              ),
            onClickView: () =>
              handleOpenImageInNewTab(cardDeliveryTerm.term?.front),
            onClickUpload: () => triggerFileCardDeliveryTermFrontPicker(),
          },
          {
            disabled: {
              download: true,
              view: false,
            },
            nome: 'Termo de Uso',
            onClickDownload: () => null,
            onClickView: () =>
              window.open(process.env.REACT_APP_MS_TERMOS_CONDICOES),
          },
          {
            disabled: {
              download: true,
              view: false,
            },
            nome: 'Politica de privacidade',
            onClickDownload: () => null,
            onClickView: () =>
              window.open(process.env.REACT_APP_MS_TERMOS_POLITICA_PRIVACIDADE),
          },
          {
            disabled: {
              download:
                documentosLimiteCredito.length === 0 &&
                !RequestUserDocuments.data?.documentoLimiteCredito,
              view:
                documentosLimiteCredito.length === 0 &&
                !RequestUserDocuments.data?.documentoLimiteCredito,
            },
            nome: 'Comprovante limite de crédito',
            onClickDownload: downloadLimitReceipts,
            onClickView: openLimitReceipts,
          },
        ],
      },
      {
        hidden: !form.temCartaoCredito,
        title: 'Documento dos benefícios',
        data: (() => {
          if (cardInfos?.data?.[0]?.categoria === 'Platinum') {
            return [...benefitsDocuments, cardInfos];
          }
          return benefitsDocuments;
        })(),
      },
      {
        hidden: !form.temCartaoCredito,
        title: 'Documento dos benefícios da central de eventos',
        data:
          benefitsDocuments?.length === 0
            ? []
            : benefitsDocuments
                ?.filter(
                  (e) =>
                    e?.contratoAtual?.origemAdesao === 'CENTRAL_EVENTOS' ||
                    e?.contratoAtual?.linkGravacaoVenda,
                )
                .flatMap((e) => {
                  const isCanceled =
                    e?.contratoAtual?.statusBeneficio === 'CANCELADO';

                  const arr = [];

                  arr.push({
                    disabled: {
                      download: false,
                      view: false,
                    },
                    nome: `Contrato ${e.contratoAtual.nome}`, // Nome do contrato atual
                    statusBeneficio: e.contratoAtual.statusBeneficio, // Status do benefício
                    onClickDownload: () =>
                      onClickDownloadWavFile(
                        e.contratoAtual?.linkGravacaoVenda,
                      ), // Função para baixar o arquivo WAV
                    onClickView: isCanceled
                      ? () =>
                          handleOpenModalCanceledBenefit(
                            e.contratoAtual.linkContrato,
                            e.contratoAtual.cancelamentoContratoPadrao,
                          )
                      : e.contratoAtual.cancelamentoContratoPadrao
                      ? () =>
                          window.open(
                            e.contratoAtual.cancelamentoContratoPadrao,
                          )
                      : () => window.open(e.contratoAtual.linkContrato),
                  });

                  return arr;
                }),
      },
      {
        title: 'Documentos dos empréstimos ',
        data:
          contractedWithdraw?.length === 0
            ? []
            : contractedWithdraw.flatMap((e) => ({
                disabled: {
                  download: e.linkContrato,
                  view: false,
                },
                nome: `TeuCard Saque a vista em ${moment(
                  e.dataPagamento,
                  'YYYY-MM-DD HH:mm',
                ).format('DD/MM/YYYY [as] HH:mm')}`,
                onClickDownload: () => onClickDownloadContract(),
                onClickView: () => window.open(e.linkContrato),
              })),
      },
      {
        title: 'Documentos gerais',
        handleClickUpload: () => setModalUploadDocumentOpen(true),
        data: [
          ...(proposalDocuments?.length === 0
            ? []
            : proposalDocuments?.flatMap((e) => ({
                disabled: {
                  download: true,
                  view: false,
                  delete: !hasRole('ADM'),
                },
                onClickDelete: !hasRole('ADM')
                  ? () => {
                      setDialogIsOpen(true);
                      setDialogText(
                        'Apenas usuários com a permissão de ADM podem excluir um arquivo!',
                      );
                    }
                  : () => {
                      setSelectedDocumentFile(e);
                      setDialogDeleteDocumentOpen(true);
                    },
                nome: e.nome,
                onClickView: () => {
                  setSelectedDocumentFile(e);

                  handleDownloadDocument(e);
                },
              }))),
          ...(diverseDocuments.length === 0
            ? []
            : diverseDocuments.map((e) => ({
                disabled: {
                  download: true,
                  view: false,
                  delete: true,
                },
                onClickDelete: !hasRole('ADM')
                  ? () => {
                      setDialogIsOpen(true);
                      setDialogText(
                        'Apenas usuários com a permissão de ADM podem excluir um arquivo!',
                      );
                    }
                  : () => {
                      setSelectedDocumentFile(e);
                      setDialogDeleteDocumentOpen(true);
                    },
                nome: e.nome,
                onClickView: () =>
                  handleOpenImageInNewTab(`data:image/png;base64, ${e.file}`),
              }))),
        ],
      },
      {
        title: 'Documentos Limite 12x',
        data:
          urlLimit12x && base64Limit12x
            ? [
                {
                  disabled: {
                    download: false,
                    view: false,
                  },
                  nome: 'Termo de Solicitação de Limite 12x',
                  onClickDownload: () => {
                    console.log('Baixando arquivo Base64...');
                    downloadBase64File(
                      base64Limit12x,
                      `Termo limite 12 x contratado ${form.nome?.value} - ${
                        Masks.cpfMask(location.state?.cpf).masked
                      }`,
                    );
                  },
                  onClickView: () => {
                    window.open(urlLimit12x, '_blank'); // abre em nova aba
                  },
                },
              ]
            : [],
      },
    ],
    [
      form,
      RequestUserDocuments,
      documentsImage,
      benefits,
      form,
      proposalDocuments,
    ],
  );
  const documentsCollapseHeight = useMemo(
    () => dataDocuments.map((e) => e?.data?.flat().flat()).flat().length * 10,
    [dataDocuments],
  );
  const cancelDocumentsCollapseHeight = useMemo(() => {
    const documentsLength = GETSearchClientCancel.data?.documentos?.length || 0;
    const invoicesLength = GETSearchClientCancel.data?.faturas?.length || 0;

    return Math.max(60, (documentsLength + invoicesLength + 4) * 16);
  }, [GETSearchClientCancel.data]);
  const hasOCRData = Boolean(GETSearchOCRProposal?.data?.campos?.length);

  return (
    <>
      <BenefitModal
        show={openBenefitsModal}
        benefits={benefitsDocuments}
        platinum={cardInfos}
        closeModal={(e) => setOpenBenefitsModal(false)}
        authorizingBenefitId={selectedOption}
        downloadPlatinum={onClickDownloadPlatinumContract}
        viewPlatinum={onClickViewPlatinumContract}
      />
      <Loading
        status={
          api.loading ||
          apiUserUpdate.loading ||
          POSTReferenceAPI.loading ||
          RequestSearchHistoricalBenefitProposal.loading ||
          GetContractedBenefits.loading ||
          GETDocumentTypes.loading ||
          GETProposalDocuments.loading ||
          POSTProposalDocuments.loading ||
          DELETEProposalDocuments.loading ||
          POSTGetDocumentBase64.loading ||
          GETSearchClientCancel.loading ||
          AuthValidatePassword.loading ||
          GetInformationKYCClient.loading ||
          DeleteRestritionKYC.loading ||
          RequestGetLimit12xDocuments.loading ||
          RequestUserDiverseDocuments.loading ||
          GetBankingDataLoan.loading
        }
      />
      <St.InputFileHidden
        ref={inputCardDeliveryTerm}
        type="file"
        accept="image/png, image/jpg, image/jpeg, application/pdf"
        onChange={(e) => fileSelected(e, 'term', 'front')}
      />
      <St.InputFileHidden
        ref={inputUploadDocument}
        type="file"
        accept="image/png, image/jpg, image/jpeg, application/pdf"
        onChange={(e) => setSelectedDocumentFile(e.target.files[0])}
      />

      <Dialog
        icon={icons.warning}
        open={dialogSizeFileMessage}
        positiveLabel="Entendi"
        positiveAction={() => setDialogSizeFileMessage(false)}
        message={`O tamanho do arquivo enviado é de ${fileSize(
          sizeFile,
        )}, o tamanho máximo permitido é de 1 MB.`}
      />
      <Dialog
        icon={icons.warning}
        open={openDialogKYC}
        title={
          <span style={{ color: '#E4003A', fontWeight: 'bold' }}>
            Liberar KYC
          </span>
        }
        message="Deseja LIBERAR o cliente para uma nova consulta ao KYC?"
        positiveLabel="SIM"
        negativeLabel="NÃO"
        positiveAction={removeRestritionKYC}
        negativeAction={() => setOpenDialogKYC(false)}
        buttonDisabledPositive={senha?.length !== 6}
      >
        <div style={{ marginTop: 20 }}>
          <Input
            name="senha"
            id="senha"
            type="password"
            label="Digite sua senha para confirmar:"
            maxLength={6}
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
          />
        </div>
      </Dialog>
      <KycHistoryDialog
        open={dialogHistoryConsultKYC}
        dataKyc={dataKYC}
        form={form}
        cpfMasked={Masks.cpfMask(location.state?.cpf).masked}
        ocrData={GETSearchOCRProposal?.data?.campos}
        senha={senha}
        onClose={() => setDialogHistoryConsultKYC(false)}
        onOpenRelease={() => setOpenDialogKYC(true)}
        onPasswordChange={(value) => setSenha(value)}
        showOptionsRule={showOptionsRule}
      />

      <DocumentUploadDialog
        open={modalUploadDocumentOpen}
        formTypeDoc={form.tipoDoc}
        selectedDocumentFile={selectedDocumentFile}
        documentTypes={
          Array.isArray(GETDocumentTypes?.data)
            ? GETDocumentTypes?.data
            : [GETDocumentTypes?.data]
        }
        inputRef={inputUploadDocument}
        onClose={() => setModalUploadDocumentOpen(false)}
        onDocumentTypeChange={(value) => setForm({ ...form, tipoDoc: value })}
        onSelectFile={() => inputUploadDocument.current?.click()}
        onSubmit={() => handleUploadFile()}
      />

      <DeleteDocumentDialog
        open={dialogDeleteDocumentOpen}
        documentName={selectedDocumentFile?.nome}
        onClose={() => setDialogDeleteDocumentOpen(false)}
        onConfirm={() => handleDeleteFile()}
      />

      <BlackListCardsDialog
        open={dialogBlackListCards}
        cards={form?.carteira?.cartoes || []}
        selectedCardId={cardNumber}
        onClose={() => setDialogBlackListCards(false)}
        onConfirm={() => removeBlacklist()}
        onSelectCard={(value) => setCardNumber(value)}
      />
      <WalletCardsDialog
        open={dialogWalletCards}
        cards={form?.carteira?.cartoes || []}
        onClose={() => setDialogWalletCards(false)}
      />

      <Dialog
        icon={icons.confirmation}
        open={dialogIsOpen}
        positiveLabel="Entendi"
        positiveAction={() => setDialogIsOpen(false)}
        message={dialogText}
      />

      <Dialog
        icon={icons.warning}
        open={dialogIsOpenError}
        positiveLabel="Entendi"
        positiveAction={() => setDialogIsOpenError(false)}
        message={dialogText}
      />

      <Dialog
        icon={icons.warning}
        open={dialogBlackListRemoveError}
        positiveLabel="Entendi"
        positiveAction={() => goBack()}
        message={dialogText}
      />

      <Dialog
        icon={icons.confirmation}
        open={dialogDocumentOpen}
        positiveLabel="Entendi"
        positiveAction={() => {
          setDialogDocumentOpen(false);
          handleGetOtherDocuments();
        }}
        message={dialogDocumentMessage}
      />
      <Dialog
        icon={icons.confirmation}
        open={dialogMessageStatus}
        positiveLabel="Entendi"
        positiveAction={() => {
          setDialogMessageStatus(false);
        }}
        message={dialogMessage}
      />

      <Dialog
        icon={icons.confirmation}
        open={dialogIsOpenSaveR}
        message="Deseja salvar as alterações, das suas referências?"
        negativeLabel="Cancelar"
        negativeAction={() => setDialogIsOpenSaveR(false)}
        positiveLabel="Continuar"
        positiveAction={addReferenceAPI}
      />

      <Dialog
        open={openDialog}
        message={popUpMessage}
        positiveAction={() => {
          setOpenDialog(false);
          //handleCustomerBase();
        }}
        positiveLabel="Entendi"
        icon={icons.check}
      />
      <Dialog
        open={popUpError}
        message={popUpErrorMessage}
        positiveAction={() => {
          setPopUpError(false);
        }}
        positiveLabel="Entendi"
        icon={icons.warning}
      />
      <Dialog
        open={modalCanceledBenefit}
        title="Deseja visualizar qual termo?"
        negativeAction={() => {
          setModalCanceledBenefit(false);
        }}
        negativeLabel="Cancelar"
        icon={icons.warning}
      >
        <ContainerFlex marginTop={20} row gap="20">
          <Button
            onClick={() => window.open(benefitContractLinks.linkContrato)}
          >
            Termo de adesão
          </Button>
          <Button
            onClick={() =>
              window.open(benefitContractLinks.linkContratoCancelado)
            }
          >
            Termo de cancelamento
          </Button>
        </ContainerFlex>
      </Dialog>

      <Container>
        <St.BoxCard>
          <ContainerFlex>
            <Collapse
              collapseHeight={120}
              title="1. Cliente"
              initialState="open"
            >
              <ClientSection
                form={form}
                errors={errors}
                setForm={setForm}
                handleCEP={handleCEP}
                getAddressByCepLoading={GetAddressByCep.loading}
                handlePictureBiometric={handlePictureBiometric}
                isLoading={isLoading}
                disabledButtonSave={disabledButtonSave}
                updateClient={updateClient}
                cpfMasked={Masks.cpfMask(location.state?.cpf).masked}
              />
            </Collapse>

            <Collapse
              initialState="close"
              collapseHeight={40}
              title="2. OCR"
              actionOnOpen={handleLoadClientOCR}
              waitRequest={GETSearchOCRProposal.loading}
            >
              <OcrSection
                hasOCRData={hasOCRData}
                loading={GETSearchOCRProposal.loading}
                isFetched={GETSearchOCRProposal.isFetched}
                error={Boolean(GETSearchOCRProposal.error)}
                data={GETSearchOCRProposal?.data?.campos}
              />
            </Collapse>

            {form.temCartaoCredito && (
              <>
                <Collapse
                  initialState="close"
                  collapseHeight={documentsCollapseHeight}
                  title={'3. Documentos'}
                  actionOnOpen={handleOpenDocumentsCollapse}
                >
                  <DocumentsSection
                    dataDocuments={dataDocuments}
                    dataBenefit={dataDocuments[3].data}
                    onSelectOption={(e) => setSelectedOption(e)}
                    onOpenDetails={(e) => setOpenBenefitsModal(e)}
                  />
                </Collapse>

                <FinancialSection
                  form={form}
                  dataBankingDataLoan={dataBankingDataLoan}
                  onOpenWalletCards={() => setDialogWalletCards(true)}
                  onOpenBlackListCards={() => setDialogBlackListCards(true)}
                  onOpenLoanSection={() => {
                    getInformationKYCClient();
                    if (api?.data?.idEmprestimo) {
                      getBankingDataLoan();
                    }
                  }}
                  onOpenKycHistory={() => {
                    if (!GETSearchOCRProposal.isFetched) handleLoadClientOCR();
                    setDialogHistoryConsultKYC(true);
                  }}
                  onOpenLoanHistory={goToHistoryLoanCelcoin}
                  tiposProdutosCartao={tiposProdutosCartao}
                  productTab={productTab}
                  cards={api.data?.cartoes}
                  onTabChange={handleProductTab}
                  onOpenCardDropdown={() => openCardDropDownAction()}
                  callbackUpdateInvoiceExpiration={
                    handleCallbackUpdateInvoiceExpiration
                  }
                  callbackClickDuplicateCard={
                    handleCallbackClickDuplicateCardReference
                  }
                  callbackBlockCard={handleCallbackBlockCard}
                />

                <Collapse
                  collapseHeight={40}
                  title={
                    form.temCarteiraDigital
                      ? '8. Dados do Cadastro/Proposta'
                      : '7. Dados do Cadastro/Proposta'
                  }
                >
                  <ProposalSection form={form} isSenff={isSenff} />
                </Collapse>
                <Collapse
                  collapseHeight={50}
                  title={
                    form.temCarteiraDigital
                      ? '9. Referências pessoais'
                      : '8. Referências pessoais'
                  }
                >
                  <ReferencesSection
                    addReference={addReference}
                    addReferenceII={addReferenceII}
                    handleChangeReference={handleChangeReference}
                    handleChangeReferenceII={handleChangeReferenceII}
                    handleSelectReference={handleSelectReference}
                    handleSelectReferenceII={handleSelectReferenceII}
                    disabledButtonSave={disabledButtonSave}
                    onSave={() => setDialogIsOpenSaveR(true)}
                  />
                </Collapse>
              </>
            )}

            {hasExperienceCancellation && (
              <CancelledContractSection
                form={form}
                collapseHeight={cancelDocumentsCollapseHeight}
                onOpen={handleOpenDocumentsCancelCollapse}
                dataResponse={GETSearchClientCancel.data}
                onClickInvoice={handleOpenInvoiceDetailFromCancel}
              />
            )}

            <ContainerFlex row end marginTop={14}>
              <Button outlined onClick={goBack} fitContent>
                Voltar
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        </St.BoxCard>
      </Container>
    </>
  );
};

export default ConsultUserDetail;
